







































































import { Component, Vue } from "vue-property-decorator";
import { clientsStore } from "@/store/modules/ClientStore";
import { inForceStore } from "@/store/modules/InForceStore";
import { opportunityStore } from "@/store/modules/OpportunityStore";

@Component
export default class extends Vue {
  get numberOfClients(): number {
    return clientsStore.statsNumberOfClients;
  }

  get numberOfBusiness(): number {
    return clientsStore.statsNumberOfBusiness;
  }

  get totalTrackedPolicies(): number {
    return inForceStore.totalTrackedPolicies;
  }

  get getTotalExistingPoliciesNoFeeds(): number {
    return this.totalLifePolicies + this.totalAnnuityPolicies;
  }
  get totalLifePolicies(): number {
    return opportunityStore.totalLifePolicies;
  }
  get totalAnnuityPolicies(): number {
    return opportunityStore.totalAnnuityPolicies;
  }
}
